import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/next';

import { useStarterDashboardV2PageFcm } from 'src/app/pages/starterDashboardV2/pageContext';

import type { PreviewEmailButtonProps } from '../../types';

export function PreviewEmailButton({ disabled, onClick }: PreviewEmailButtonProps): JSX.Element | null {
	const { petitionUpdateEmailPreviewEnabled } = useStarterDashboardV2PageFcm();

	if (!petitionUpdateEmailPreviewEnabled) {
		return null;
	}

	return (
		<Button
			className="w-full md:w-[200px]"
			variant="secondary"
			data-testid="preview-petition-update"
			data-qa="preview-petition-update"
			onClick={onClick}
			type="button"
			disabled={disabled}
			size="large"
		>
			Preview
		</Button>
	);
}
